<template lang='pug' src='./custom-home-testimonials.pug'></template>

<script>
import Icon from 'components/icon/icon'
import { openModal } from '@/methods'
import RandomSizeDirective from './custom-home-testimonials.directive'

export default {
  data () {
    return {
      galleryLoaded: false,
      modalActive: false,
      videoTestimonial: '',
      buttonHidden: false,
      orthodontic: true,
      styleWidth: '',
      styleHeight: '',
      styleTop: '',
      styleLeft: '',
      dropdownActive: false,
      active: 1
    }
  },
  props: ['props'],
  mounted () {
    this.toggleWords()
  },
  computed: {
    video () {
      return this.$refs.video
    },
    links () {
      return this.$router.options.routes
    },
    dropdownBackgroundStyleObject () {
      return {
        height: this.styleHeight,
        width: this.styleWidth,
        top: this.styleTop,
        left: this.styleLeft
      }
    }
  },
  mixins: [openModal],
  directives: {
    RandomSizeDirective
  },
  components: {
    Icon
  },
  methods: {
    loadMore () {
      this.galleryLoaded = true
      this.buttonHidden = true
      // TODO toggle hidden / unhidden
    },
    openTestiModial (src) {
      this.modalActive = true
      this.videoTestimonial = src
    },
    closeTestiModial () {
      this.modalActive = false
      this.video.pause()
    },
    toggleWords () {
      this.orthodontic = !this.orthodontic
      setTimeout(() => { this.toggleWords() }, 2500)
    },
    handleEnter (e, i) {
      this.dropdownActive = true
      this.active = i

      const navCoords = e.target.parentElement.getBoundingClientRect()

      setTimeout(() => {
        const coords = e.target.children[0].getBoundingClientRect()
        this.styleWidth = coords.width + 'px'
        this.styleHeight = coords.height + 'px'
        this.styleTop = coords.top - navCoords.top + 'px'
        this.styleLeft = coords.left - navCoords.left + 'px'
      }, 100)
    },
    handleLeave () {
      this.dropdownActive = false
      this.active = false
      // this.styleWidth = ''
      // this.styleHeight = ''
      // this.styleTop = ''
      // this.styleLeft = ''
    },
    handleRoute (e) {
      this.$router.push(e.path)
      this.handleLeave()
    },
    goToConsultation () {
      this.$router.push('/free-orthodontic-consultation')
    },
    goToPediatric () {
      this.$router.push('/pediatric-appointment')
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-testimonials.vue?2457829f